import { Icon } from "@blueprintjs/core"
import CustomCheckbox from "components/Atoms/CustomCheckbox"
import StyledLink from "components/Atoms/StyledLink"
import CustomReactTable from "components/Templates/CustomReactTable"
import useRouteStore from "pages/fsm/routes.store"
import React from "react"

const BeatListView = ({ data, disabled = false, loading = false }) => {
  const COLUMNS = [
    {
      width: 50,
      Header: "#",
      accessor: "sequence",
      Cell({ value }) {
        return value || "-"
      },
    },
    {
      width: 50,
      Cell({ original }) {
        const toggleSelect = useRouteStore(store => store.toggleOutletSelect)

        const isSelected = original?.sequence ? true : false
        return (
          <CustomCheckbox
            disabled={disabled}
            onChange={() => toggleSelect(original)}
            checked={isSelected}
            className="m-0"
          />
        )
      },
    },
    {
      width: 120,
      Header: "Status",
      accessor: "status",
      Cell({ value }) {
        return (
          <>
            <Icon icon="dot" intent={value ? "success" : "danger"} />
            {value ? "Active" : "Inactive"}
          </>
        )
      },
    },
    {
      width: 300,
      Header: "Address",
      accessor: "address.village",
    },
    {
      Header: "Customer Name",
      accessor: "fullName",
      Cell({ value, original }) {
        return (
          <StyledLink to={`/d/registration/vendors/details/${original.id}`}>
            {value}
          </StyledLink>
        )
      },
    },
    {
      Header: "Customer Number",
      accessor: "number",
    },
    {
      width: 240,
      Header: "Category",
      accessor: "route.category",
    },
  ]
  return (
    <CustomReactTable
      pageSize={data?.length > 13 ? data?.length : 13}
      loading={loading}
      loadingText="Loading..."
      className="h-[70vh] rounded-lg"
      columns={COLUMNS}
      data={data}
    />
  )
}

export default BeatListView
